import * as React from 'react'

import { PrimaryButton, Space } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { ActiveUsersWithSlackListPresenter } from '@webapp/platform/integrations/features/list-active-users-with-slack'
import messages from './messages'
import { useSlackUserLinkingSection } from './useSlackUserLinkingSection'

// Slack documentation link for setting up the integration
const SLACK_SETUP_HELP_URL =
  'https://help.procurify.com/en/articles/slack-integration'

export const SlackUserLinkingSection = () => {
  const intl = useProcurifyIntl()
  const {
    data: { slackUserCache },
    methods: { handleUserLinkChange, syncUnlinkedUsers },
    states: { isSyncing },
  } = useSlackUserLinkingSection()

  return (
    <Space direction='vertical' align='stretch'>
      <Space direction='horizontal' justify='space-between' align='center'>
        <PrimaryButton isLoading={isSyncing} onClick={syncUnlinkedUsers}>
          {intl.formatMessage(messages.syncButtonLabel)}
        </PrimaryButton>
        <a
          href={SLACK_SETUP_HELP_URL}
          target='_blank'
          rel='noopener noreferrer'
        >
          {intl.formatMessage(messages.learnHowLinkText)}
        </a>
      </Space>
      <ActiveUsersWithSlackListPresenter
        slackUserCache={slackUserCache}
        onUserLinkChange={handleUserLinkChange}
      />
    </Space>
  )
}
